import classNames from "classnames";
import pcComachi from "images/introduction/PC.png";
import credit from "images/introduction/credit.png";
import apps from "images/introduction/apps.png";
import React from "react";
import Style from "styles/components/introduction.module.scss";
import useScrollAnimation from "hooks/useScrollAnimation";

const Introduction = () => {
  const [sectionRef, isVisible] = useScrollAnimation(0.15);

  return (
    <>
      <div className={Style.introduction}>
        <div className={classNames(Style.introduction__catch)}>
          ネットショップを始めるには<br />
          専門知識を自分で調べて学ぶ必要があり、想像以上に大変です<br />
        </div>
        <div className={classNames(Style.introduction__comachicart)}>
          でも、
          <span className={classNames(Style.introduction__comachicart__hasBlueText)}>
            comachicartなら大丈夫。<br />
          </span>
        </div>
        <div className={classNames(Style.introduction__triangleWrapper)}>
          <div className={classNames(Style.introduction__triangle, Style.introduction__triangle__1)}></div>
          <div className={classNames(Style.introduction__triangle, Style.introduction__triangle__2)}></div>
        </div>
      </div>

      <section ref={sectionRef} className={classNames(Style.features, { [Style.features__visible]: isVisible })}>
        <div className={Style.features__head}>
          <span className={Style.features__eyebrow}>Features</span>
          <h2 className={Style.features__title}>
            コマチカートが選ばれる<strong>3つの理由</strong>
          </h2>
        </div>

        <div className={Style.features__cards}>
          {/* CARD 01 */}
          <div className={classNames(Style.card, { [Style.card__visible]: isVisible })}>
            <div className={Style.card__head}>
              <h3 className={Style.card__title}>
                <span className={Style.card__num}>01</span>
                <span className={Style.card__big}>ショップ無料開設</span>
                月額無料でスタート！
              </h3>
            </div>
            <div className={Style.card__img}>
              <img src={pcComachi} alt="コマチカート 管理画面" />
            </div>
            <div className={Style.card__body}>
              <ul className={Style.card__list}>
                <li>初期費用・月額費用が0円</li>
                <li>無料でネットショップ開設</li>
              </ul>
            </div>
          </div>

          {/* CARD 02 */}
          <div className={classNames(Style.card, { [Style.card__visible]: isVisible })}>
            <div className={Style.card__head}>
              <h3 className={Style.card__title}>
                <span className={Style.card__num}>02</span>
                クレジット決済費用
                <span className={Style.card__big}>3.2%</span>
                ショップ利益を最大に！
              </h3>
            </div>
            <div className={Style.card__img}>
              <img src={credit} alt="クレジット決済" />
            </div>
            <div className={Style.card__body}>
              <p className={Style.card__note}>※VISA/MASTERは3.2%、AMEX/JCB/DINERSは3.3%</p>
              <ul className={Style.card__list}>
                <li>Comachiは決済手数料3.2%</li>
                <li>A社は決済手数料3.6%＋40円</li>
                <li>B社は決済手数料6.6%</li>
              </ul>
            </div>
          </div>

          {/* CARD 03 */}
          <div className={classNames(Style.card, { [Style.card__visible]: isVisible })}>
            <div className={Style.card__head}>
              <h3 className={Style.card__title}>
                <span className={Style.card__num}>03</span>
                基本機能が充実、
                <span className={Style.card__big}>売上UP！</span>
              </h3>
            </div>
            <div className={Style.card__img}>
              <img src={apps} alt="アプリ機能" />
            </div>
            <div className={Style.card__body}>
              <ul className={Style.card__list}>
                <li>運営に必要な販促機能は標準搭載</li>
                <li>アプリ機能を使って運営の幅を広げる</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Introduction;
